export enum Gender {
    Male = 0,
    Female = 1,
    NonBinary = 2,
    Other = 3,
    PreferNotToSay = 4,
    NotChosen = 5
}
